import React, { Component } from 'react'
import Table from '@common/Table'
import store from './store'
import columns from './column'
import SearchBar from './searchBar'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    store.id = props.id
  }

  render() {
    const { selectedRowKeys, selectChange, ids } = this.props
    const rowSelection = {
      selectedRowKeys: selectedRowKeys.length ? selectedRowKeys : ids,
      getCheckboxProps: record => {
        const disabled = ids.findIndex(item => item === record.id)
        return {
          disabled: disabled >= 0
        }
      },
      onChange: selectedRowKeys => {
        selectChange(selectedRowKeys)
      }
    }

    return (
      <div>
        <SearchBar />
        <Table
          rowSelection={rowSelection}
          store={store}
          columns={columns}
          rowKey="id"
        />
      </div>
    )
  }
}
